/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';
import { getTopicTitle } from '@e180/domain/lib/topic/util';

import styles from './TopicCardTitle.style';
import { getElementLineCount } from 'src/shared/core/util/domUtil';
import { markFMP } from 'src/shared/core/util/performanceUtils';

import type { Topic } from '@e180/domain/lib/topic/type';

type Props = {
  topic: Topic,
  trackFMP?: boolean,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const TopicCardTitle = ({ trackFMP, topic, intl }: Props): React.Node => {
  const title = getTopicTitle(topic, intl.locale);

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    if (trackFMP) {
      markFMP();
    }

    adustTitle();
  }, []);

  /*
   |----------------------------------------------------------------------------
   | Functions
   |----------------------------------------------------------------------------
   */

  const adustTitle = () => {
    const { current: titeElt } = titleRef;

    if (titeElt) {
      // $FlowIssue
      const lines = getElementLineCount(titeElt) || 0;

      if (lines < 3) {
        // $FlowIssue
        titeElt.className += ` ${classes['title-withSeparator']}`;
      } else if (lines > 3) {
        // $FlowIssue
        titeElt.className += ` ${classes['title-hasOverflown']}`;
      }
    }
  };

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Refs
   |----------------------------------------------------------------------------
   */

  const titleRef = React.createRef();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <span className={classes.root}>
      <span className={classes.title} ref={titleRef}>
        {title}
      </span>
    </span>
  );
};

export default compose(React.memo, injectIntl)(TopicCardTitle);
